import { MatTableDataSourceBackendExtended } from "@comunicare/comunicare-angular-interfaces";
import { IDataSourceBackendParam, IPatientDataSourceBackendParam, IPatientsListInfo } from "@comunicare/comunicare-interfaces";
import { Observable, of } from "rxjs";
import { PatientService } from "src/app/providers/patient.service";

export class PatientDataSource extends MatTableDataSourceBackendExtended<IPatientsListInfo> {
  public rawData$ = this.dataSubject.asObservable();
  constructor(private patientService: PatientService) {
    super();
  }

  public data(params: IPatientDataSourceBackendParam): Observable<IPatientsListInfo[]> {
    if (!params.services || params.services.length < 1) {
      return of([]);
    }
    return this.patientService.findPatient(params);
  }
  protected dataCount(_param: IDataSourceBackendParam): Observable<number> {
    /*
      Use this, the day we decide to make the page implements AbstractBackendTablePage
    */
    return of(0);
  }
}
